const ChartToolbar = ({ children }) => (
  <div className="chart__toolbar">{children}</div>
)

export default ChartToolbar
